import type { Sponsor, Supporter } from '@/types/sponsors';
import { supabase, isSupabaseConfigured } from '@/lib/supabase';

function notConfigured() {
  throw new Error('Supabaseが設定されていません。.env に VITE_SUPABASE_URL と VITE_SUPABASE_ANON_KEY を設定してください。');
}

export async function createSponsor(data: Omit<Sponsor, 'id' | 'created_at'>) {
  if (!isSupabaseConfigured() || !supabase) notConfigured();
  const { data: row, error } = await supabase!
    .from('sponsors')
    .insert(data)
    .select()
    .single();
  if (error) throw new Error(error.message);
  return row as Sponsor;
}

export async function updateSponsor(id: string, data: Partial<Sponsor>) {
  if (!isSupabaseConfigured() || !supabase) notConfigured();
  const { error } = await supabase!.from('sponsors').update(data).eq('id', id);
  if (error) throw new Error(error.message);
}

export async function deleteSponsor(id: string) {
  if (!isSupabaseConfigured() || !supabase) notConfigured();
  const { error } = await supabase!.from('sponsors').delete().eq('id', id);
  if (error) throw new Error(error.message);
}

export async function createSupporter(data: Omit<Supporter, 'id' | 'created_at'>) {
  if (!isSupabaseConfigured() || !supabase) notConfigured();
  const { data: row, error } = await supabase!
    .from('supporters')
    .insert(data)
    .select()
    .single();
  if (error) throw new Error(error.message);
  return row as Supporter;
}

export async function updateSupporter(id: string, data: Partial<Supporter>) {
  if (!isSupabaseConfigured() || !supabase) notConfigured();
  const { error } = await supabase!.from('supporters').update(data).eq('id', id);
  if (error) throw new Error(error.message);
}

export async function deleteSupporter(id: string) {
  if (!isSupabaseConfigured() || !supabase) notConfigured();
  const { error } = await supabase!.from('supporters').delete().eq('id', id);
  if (error) throw new Error(error.message);
}

const LOGOS_BUCKET = 'logos';

export async function uploadLogo(file: File): Promise<string> {
  if (!isSupabaseConfigured() || !supabase) notConfigured();
  const ext = file.name.split('.').pop() || 'png';
  const path = `${crypto.randomUUID()}.${ext}`;
  const { error } = await supabase!.storage.from(LOGOS_BUCKET).upload(path, file);
  if (error) throw new Error(error.message);
  const { data } = supabase!.storage.from(LOGOS_BUCKET).getPublicUrl(path);
  return data.publicUrl;
}
